import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

const REPEATS = 4;
const OVERFLOW = 2;

/**
 * @param {object} options
 * @param {number} options.count
 * @param {React.ReactNode} options.children
 * @returns
 */
const Repeat = ({ count, children }) => {
    return Array.from({ length: count }, (_, i) => i).map((el) => (
        <React.Fragment key={el}>{children}</React.Fragment>
    ));
};

/**
 * @type {import('$types/components/partials/ui.d.ts').Marquee}
 */
const Marquee = ({
    className,
    id = '',
    children: _children
}) => {
    if (!_children) { return null; }

    const children = Array.isArray(_children) ? _children : [_children];
    const total = (children.length * REPEATS);
    const itemMinWidth = Math.max(100 / total, 25);

    const cssId = `${id.replace(/[!\"#$%&'\(\)\*\+,\.\/:;<=>\?\s\@\[\\\]\^`\{\|\}~]/g, '')}`;

    return (
        <div className={`overflow-hidden${className ? ` ${className}` : ''}`}>
            <style dangerouslySetInnerHTML={{__html: `
                .marquee-${cssId} {
                    animation-duration: ${(total * itemMinWidth) * 1}s;
                }
            `}} />

            <div className='sr-only'>
                {children}
            </div>

            <ul
                aria-hidden={true}
                className={`marquee marquee-${cssId}`}>

                <Repeat count={REPEATS * OVERFLOW}>
                    {children.map((child, i) => {
                        return (
                            <li
                                className={`marquee__item marquee__item-${cssId} inline-block`}
                                key={i}>
                                {child}
                            </li>
                        );
                    })}
                </Repeat>
            </ul>
        </div>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default Marquee;
